import Responses from "../../../../src/pages/api/search-files-responses.md";
import * as React from 'react';
export default {
  Responses,
  React
};